var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSorting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 19C5.99997 19.5523 6.44769 20 6.99997 20C7.55226 20 7.99997 19.5523 7.99997 19V7.41422L10.2929 9.70711C10.6834 10.0976 11.3166 10.0976 11.7071 9.70711C12.0976 9.31658 12.0976 8.68342 11.7071 8.29289L7.71175 4.29756L7.70711 4.29289C7.60846 4.19424 7.49432 4.12052 7.37253 4.07171C7.25739 4.02545 7.13165 4 6.99997 4C6.8591 4 6.72504 4.02913 6.60347 4.08169C6.50781 4.12296 6.41728 4.17988 6.33577 4.25243C6.32429 4.26264 6.31304 4.27312 6.30203 4.28384L6.28836 4.29743L2.29289 8.29289C1.90237 8.68342 1.90237 9.31658 2.29289 9.70711C2.68342 10.0976 3.31658 10.0976 3.70711 9.70711L5.99997 7.41424V19Z",
    fill: "#00AB9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5C18 4.44772 17.5523 4 17 4C16.4477 4 16 4.44771 16 5L16 16.5858L13.7071 14.2929C13.3166 13.9024 12.6834 13.9024 12.2929 14.2929C11.9024 14.6834 11.9024 15.3166 12.2929 15.7071L16.2882 19.7024L16.2929 19.7071C16.3915 19.8058 16.5056 19.8795 16.6274 19.9283C16.7426 19.9745 16.8683 20 17 20C17.1409 20 17.2749 19.9709 17.3965 19.9183C17.4922 19.877 17.5827 19.8201 17.6642 19.7476C17.6757 19.7374 17.6869 19.7269 17.6979 19.7162L17.7116 19.7026L21.7071 15.7071C22.0976 15.3166 22.0976 14.6834 21.7071 14.2929C21.3166 13.9024 20.6834 13.9024 20.2929 14.2929L18 16.5858L18 5Z",
    fill: "#00AB9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorting);
export default __webpack_public_path__ + "static/media/sorting.d41bab33029d07ce71a62bc9eaf6f104.svg";
export { ForwardRef as ReactComponent };